import { memo, useCallback, useRef } from "react";
import styles from "./styles.module.css";

/** Served from public folder so the path works regardless of route. */
const VIDEO_URL = `${process.env.PUBLIC_URL || ""}/assets/blazepod-showcase-optimized.mp4`;

/**
 * Native HTML5 video player. Uses <video> instead of previously used ReactPlayer
 * to reduce CPU/JS overhead on low-powered devices (e.g. smart TVs).
 * This lets the browser handle decoding and compositing
 * with minimal React involvement for optimal performance.
 */
function VideoPlayerComponent() {
  const videoRef = useRef<HTMLVideoElement>(null);

  /**
   * Loop is implemented via onEnded because the HTML5 `loop` attribute is often
   * ignored or broken on Smart TV browsers (Tizen, webOS, etc.).
   */
  const handleEnded = useCallback(() => {
    const el = videoRef.current;
    if (el) {
      el.currentTime = 0;
      el.play().catch(() => {});
    }
  }, []);

  return (
    <div className={styles.videoContainer}>
      <video
        ref={videoRef}
        src={VIDEO_URL}
        muted
        loop
        playsInline
        autoPlay
        preload="auto"
        disablePictureInPicture
        disableRemotePlayback
        onEnded={handleEnded}
        className={styles.video}
      />
    </div>
  );
}

export const VideoPlayer = memo(VideoPlayerComponent);
